import React from 'react';
import Container from '../../../containers/integration/webhooks/showWebhookContainer';

export default function () {
  return (
    <Container />
  );
}
